
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import {useEvent} from './useEvent'
import { updateItemActorFieldValue,deleteItemActorField,UpdateExporterForMultipleExporter,updateExporterForAllTheInvoices} from '../actions';
import { SAVE_ITEM_CDS } from '../api/apiEvents'; 
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType'

export const useItemActor=(containerKey="parties")=>{
 const {saveForm,deleteForm}=useEvent("invoice",true)
 const {isImportShipment}=useCurrentShipmentType()
 const dispatch = useDispatch();

 
  const saveItemActorDetails = useCallback(async(params={},invoiceId) => {
     try{
         const type=params.actorType.toUpperCase()
         params.type=type
        const response=await saveForm({"invoiceList":{[invoiceId]:{[`${params.actorType}`]:params}}},true,SAVE_ITEM_CDS)
        if(response && !params.id){
            if(params.actorType ==='exporter' && isImportShipment){
                dispatch(UpdateExporterForMultipleExporter(response?.parties?.exporter))
                Object.entries(response?.invoice?.invoiceList).forEach(([key, value]) => {
                     dispatch(updateExporterForAllTheInvoices(key,value.exporter))
                });
            }
            const {id,invoiceActorRoleId,roleId} = response.invoice.invoiceList[invoiceId][params.actorType];
            dispatch(updateItemActorFieldValue(params.actorType, {id,invoiceActorRoleId,roleId},invoiceId))
        }
     }
     catch(e){

     }
  }, [saveForm]); 
  
  const deleteItemActorParties = useCallback(async(params={},invoiceId) => {
    try{
        const type=params.actorType.toUpperCase()
        params.type=type
        const response=await deleteForm({"invoiceList":{[invoiceId]:{[`${params.actorType}`]:params}}})
       if(response){
        dispatch(deleteItemActorField(params.actorType,invoiceId))
       }
    }
    catch(e){
    }
 }, [deleteForm]); 
 
 


  return React.useMemo(()=>({
      saveItemActorDetails,
      deleteItemActorParties,
      updateNextedActorFieldValue:(actorType,payload,invoiceId)=>dispatch(updateItemActorFieldValue(actorType,payload,invoiceId)),
    }),[
        saveItemActorDetails,
        updateItemActorFieldValue,deleteItemActorParties])
}